<template>
    <div 
        class="layout-external defaultTheme"
        :style="{ '--bg-mobile': `url(${backgroundMobileSrc})` }"
    >
        <div class="left">
            <img
                :src="logoSrc"
                class="logo"
                alt="Logo P2U"
            />
            <router-view />
        </div>
        <div class="right">
            <img
                :src="fundoBordaSrc"
                class="background-desktop"
                alt="Background desktop"
            />
            </div>
    </div>
</template>

<script>
    import { defineComponent } from 'vue'
    import logoSrc from '@/assets/images/logo.png'
    import fundoBordaSrc from '@/assets/images/fundoBorda.png'
    import backgroundMobileSrc from '@/assets/images/background-external-mobile.png'

    export default defineComponent({
        name: 'LayoutRegistro',
        setup() {
            return {
                logoSrc,
                fundoBordaSrc,
                backgroundMobileSrc,
            }
        },
    })
</script>

<style lang="scss">
    .layout-external {
        display: flex;
        flex-direction: column;
        min-height: 100vh;
        width: 100%;
        overflow-x: hidden;
        background-image: var(--bg-mobile);
        background-repeat: no-repeat;
        background-position: center bottom;
        background-size: 100%;
        background-attachment: scroll;

        .left {
            margin-left: 8vw;
            margin-right: 8vw;
            margin-top: 5vh;
            width: calc(100% - 16vw);
            z-index: 2;
            padding-bottom: 2rem;

            .logo {
                height: 11vh;
                max-width: 100%;
                margin-bottom: 1rem;
            }
        }

        .right {
            display: none; 
        }
    }

    /* Desktop */
    @media only screen and (min-device-width: 900px) {
        .layout-external {
            width: 100vw;
            height: 100vh;
            min-height: auto;
            display: flex;
            flex-direction: row;
            overflow-x: hidden;
            background-image: none !important; 

            .left {
                width: 82vw;
                height: 80vh;
                margin-left: 8.5vw;
                margin-right: 0;
                margin-top: 4rem;
                padding-bottom: 0; 
                overflow-y: auto;
                
                &::-webkit-scrollbar {
                    width: 0px;
                    background: transparent;
                }

                .logo {
                    height: 5rem;
                }
            }

            .right {
                display: flex;
                width: 9.5vw;
                height: 100vh;
                margin-top: 0;
                flex-direction: row;
                align-items: center;
                justify-content: flex-end;
                position: relative;

                .background-desktop {
                    display: block;
                    height: 100vh;
                }
            }
        }
    }
</style>